import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { AppState } from '../../store';
import { selectAccountId } from '../../account/store/account.selectors';
import { Hook, HookEvent, HookType } from '../hook.models';
import { QueryParams } from '../../models/http.models';

@Injectable({
  providedIn: 'root',
})
export class HooksResource {
  private apiRoot: string = `${process.env.API_URL}`;

  constructor(private http: HttpClient, private store: Store<AppState>) {}

  get(hook_id: number, params?: QueryParams): Observable<Hook> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) => this.http.get<Hook>(`${this.apiRoot}/${account_id}/api/hooks/${hook_id}`, { params })),
    );
  }

  save(body: Partial<Hook>, params?: QueryParams): Observable<Hook> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) => this.http.post<Hook>(`${this.apiRoot}/${account_id}/api/hooks`, body, { params })),
    );
  }

  update(hook_id: number, body: Partial<Hook>, params?: QueryParams): Observable<Hook> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.put<Hook>(`${this.apiRoot}/${account_id}/api/hooks/${hook_id}`, body, { params }),
      ),
    );
  }

  remove(hook_id: number, params?: QueryParams): Observable<any> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.delete<Hook>(`${this.apiRoot}/${account_id}/api/hooks/${hook_id}`, { params }),
      ),
    );
  }

  query(params?: QueryParams): Observable<Hook[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) => this.http.get<Hook[]>(`${this.apiRoot}/${account_id}/api/hooks`, { params })),
    );
  }

  search(params?: QueryParams): Observable<Hook[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) => this.http.get<Hook[]>(`${this.apiRoot}/${account_id}/api/hooks/search`, { params })),
    );
  }

  ping(hook_id: number, params?: QueryParams): Observable<Hook> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<Hook>(`${this.apiRoot}/${account_id}/api/hooks/${hook_id}/ping`, { params }),
      ),
    );
  }

  types(params?: QueryParams): Observable<HookType[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) => this.http.get<HookType[]>(`${this.apiRoot}/${account_id}/api/hooks/types`, { params })),
    );
  }

  hookEvents(params?: QueryParams): Observable<HookEvent[]> {
    return this.http.get<HookEvent[]>(`${this.apiRoot}/hook_events`, { params });
  }
}
